import Button from "@mui/material/Button";
import { useOrientationToggle } from "../hooks/useOrientationToggle";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import { useTranslation } from "react-i18next";

export const OrientationToggle = () => {
  const { onOrientationChange } = useOrientationToggle();
  const { t } = useTranslation("common");

  return (
    <Button fullWidth sx={{ marginTop: '25px' }} onClick={onOrientationChange} variant={"outlined"}>
      <RotateLeftIcon />
      {t("settings.changeRotation")}
    </Button>
  );
};
